import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import attributeActions from "../../../store/actions/items/attributes/attribute.actions";
import { itemAttributeModel } from "../../../models/items/attributes/attribute.model";
import { useParams, useNavigate } from "react-router-dom";

export const EditAttributePageComponent = ({ attributeActions }) => {
  const { id } = useParams(); // Get attribute ID from URL
  const navigate = useNavigate();
  const [attributeDetails, setAttributeDetails] = useState(itemAttributeModel); // Default model
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch attribute details on component mount
  useEffect(() => {
    if (id) {
      fetchAttributeDetails(id);
    }
  }, [id]);

  const fetchAttributeDetails = async (attributeId) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await attributeActions.getAttributeById(attributeId);
      setAttributeDetails(response.payload); // Populate form with fetched data
    } catch (error) {
      console.error("Error fetching attribute details:", error);
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setAttributeDetails({ ...attributeDetails, [name]: value });
  };

  const handleUpdateAttribute = async (event) => {
    event.preventDefault(); // Prevent default form submission
    setIsLoading(true);
    setError(null);

    try {
      const response = await attributeActions.updateAttribute(attributeDetails);
      console.log("Attribute updated successfully:", response);
      navigate("/attributes"); // Navigate back to attributes list
    } catch (error) {
      console.error("Error updating attribute:", error);
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h2>Edit Attribute</h2>
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>Error: {error.message || "Something went wrong"}</p>
      ) : (
        <form onSubmit={handleUpdateAttribute}>
          <div>
            <label htmlFor="name">Attribute Name:</label>
            <input type="text" id="name" name="name" value={attributeDetails.name} onChange={handleInputChange} required />
          </div>
          <div>
            <label htmlFor="description">Description:</label>
            <input type="text" id="description" name="description" value={attributeDetails.description} onChange={handleInputChange} required />
          </div>
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Updating..." : "Update Attribute"}
          </button>
        </form>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    attributeActions: bindActionCreators(attributeActions, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(EditAttributePageComponent);
